import { Actions, ActionTypes } from '@appStore/selfservice/actions';
import { SelfServiceAgreement } from '@model';

export interface State {
    activeAgreementLink: string;
    activeAgreementLinkLoading: boolean;
    activeAgreementLinkLoaded: boolean;
    selfServiceAgreements: SelfServiceAgreement[];
    selfServiceAgreementsLoading: boolean;
    selfServiceAgreementsLoaded: boolean;
    selfServiceAgreementCreated: boolean;
    selfServiceAgreementCreatedLoading: boolean;
    selfServiceAgreementCreatedLoaded: boolean;
    selfServiceAgreementId: number;
}

export const initialState: State = {
    activeAgreementLink: null,
    activeAgreementLinkLoading: false,
    activeAgreementLinkLoaded: false,
    selfServiceAgreements: null,
    selfServiceAgreementsLoading: false,
    selfServiceAgreementsLoaded: false,
    selfServiceAgreementCreated: false,
    selfServiceAgreementCreatedLoading: false,
    selfServiceAgreementCreatedLoaded: false,
    selfServiceAgreementId: null
}

export function reducer(state = initialState, action: Actions): State {

    switch(action.type) {
 
        case ActionTypes.AgreementLinkLoad:
            return {...state, activeAgreementLink: null, activeAgreementLinkLoaded: false, activeAgreementLinkLoading: true };
        case ActionTypes.AgreementLinkLoadSuccess:
            return {...state, activeAgreementLink: action.payload, activeAgreementLinkLoaded: true, activeAgreementLinkLoading: false };
        case ActionTypes.AgreementLinkLoadFail:
            return {...state, activeAgreementLink: null, activeAgreementLinkLoaded: false, activeAgreementLinkLoading: false };
        
        case ActionTypes.SelfServiceAgreementsLoad:
                return { ...state, selfServiceAgreementsLoaded: false, selfServiceAgreementsLoading: true };
        case ActionTypes.SelfServiceAgreementsLoadSuccess:
            return { ...state,
                selfServiceAgreementsLoaded: true,
                selfServiceAgreementsLoading: false,
                selfServiceAgreements: action.payload };
        case ActionTypes.SelfServiceAgreementsLoadFail:
                return { ...state, selfServiceAgreementsLoaded: false, selfServiceAgreementsLoading: false };

        case ActionTypes.CreateSelfServiceAgreement:
            return {...state,
                selfServiceAgreementCreated: false,
                selfServiceAgreementCreatedLoading: true,
                selfServiceAgreementCreatedLoaded: false,
                selfServiceAgreementId: null };
        case ActionTypes.CreateSelfServiceAgreementSuccess:
            return {...state, 
                selfServiceAgreementCreated: true,
                selfServiceAgreementCreatedLoading: false,
                selfServiceAgreementCreatedLoaded: true,
                selfServiceAgreementId: action.payload };
        case ActionTypes.CreateSelfServiceAgreementFail:
            return {...state, 
                selfServiceAgreementCreated: false,
                selfServiceAgreementCreatedLoading: false,
                selfServiceAgreementCreatedLoaded: false,
                selfServiceAgreementId: null };
    }
    
    return state;
}

export const getActiveAgreementLink = (state: State) => state.activeAgreementLink;
export const getActiveAgreementLinkLoaded = (state: State) => state.activeAgreementLinkLoaded;
export const getSelfServiceAgreements = (state: State) => state.selfServiceAgreements;
export const getSelfServiceAgreementsLoaded = (state: State) => state.selfServiceAgreementsLoaded;
export const getSelfServiceAgreementCreated = (state: State) => state.selfServiceAgreementCreated;
export const getSelfServiceAgreementCreateId = (state: State) => state.selfServiceAgreementId;